import React, { useEffect, useState } from "react";
import axios from "axios";
import { Trash2, Inbox, RefreshCw } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/leads`);
      setLeads(res.data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="bg-[#0F172A] text-white">
        <div className="mx-auto max-w-6xl px-6 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#2563EB]">
              <Trash2 className="h-5 w-5" />
            </span>
            <div>
              <div className="font-display font-bold">Coastal Valet Trash</div>
              <div className="text-xs text-slate-400">Lead Inbox</div>
            </div>
          </div>
          <button
            data-testid="admin-refresh"
            onClick={load}
            className="inline-flex items-center gap-2 rounded-md bg-white/10 px-4 py-2 text-sm font-medium hover:bg-white/20 transition-colors"
          >
            <RefreshCw className="h-4 w-4" /> Refresh
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-10">
        <div className="flex items-center gap-2 mb-6">
          <Inbox className="h-5 w-5 text-[#2563EB]" />
          <h1 className="font-display text-2xl font-bold text-[#1E293B]">
            Proposal Requests ({leads.length})
          </h1>
        </div>

        {loading ? (
          <p className="text-[#475569]">Loading...</p>
        ) : leads.length === 0 ? (
          <div className="rounded-xl border border-gray-200 bg-white p-12 text-center text-[#475569]">
            No leads yet. New proposal requests will appear here.
          </div>
        ) : (
          <div className="overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm">
            <table className="w-full text-sm">
              <thead className="bg-[#F1F5F9] text-left text-[#475569]">
                <tr>
                  <th className="px-4 py-3 font-semibold">Name</th>
                  <th className="px-4 py-3 font-semibold">Phone</th>
                  <th className="px-4 py-3 font-semibold">Email</th>
                  <th className="px-4 py-3 font-semibold">Property</th>
                  <th className="px-4 py-3 font-semibold">Units</th>
                  <th className="px-4 py-3 font-semibold">Message</th>
                  <th className="px-4 py-3 font-semibold">Date</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {leads.map((l) => (
                  <tr key={l.id} data-testid={`lead-row-${l.id}`} className="hover:bg-[#F8FAFC]">
                    <td className="px-4 py-3 font-medium text-[#1E293B]">{l.name}</td>
                    <td className="px-4 py-3 text-[#334155]">{l.phone}</td>
                    <td className="px-4 py-3 text-[#334155]">{l.email}</td>
                    <td className="px-4 py-3 text-[#334155]">{l.property_name || "—"}</td>
                    <td className="px-4 py-3 text-[#334155]">{l.number_of_units || "—"}</td>
                    <td className="px-4 py-3 text-[#475569] max-w-xs truncate">{l.message || "—"}</td>
                    <td className="px-4 py-3 text-[#475569] whitespace-nowrap">
                      {new Date(l.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
